var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faqs__list"},_vm._l((JSON.parse(_vm.faqs)),function(faq,index){return _c('div',{key:index,staticClass:"faqs__list__items"},[_c('faq-list-item',{attrs:{"question":faq.question,"answer":faq.answer}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/bpbauto.stagingwebsite.dev/web/app/themes/bpb/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/bpbauto.stagingwebsite.dev/web/app/themes/bpb/node_modules/vue-loader/lib?{}!./scripts/vue/FaqList.vue?vue&type=template&id=c1873f18&scoped=true&
// module id = 242
// module chunks = 0